import { c as _c } from "react/compiler-runtime";
import { formatDate } from '@/shared/formatters';
import type { EventoLinhaTempoSentenca } from '../../../types/sentencaArbitral.types';
interface SecaoLinhaTempoSentencaProps {
  eventos: readonly EventoLinhaTempoSentenca[];
}
export function SecaoLinhaTempoSentenca(t0) {
  const $ = _c(6);
  const {
    eventos
  } = t0;
  let t1;
  if ($[0] !== eventos) {
    let t2;
    if ($[2] !== eventos.length) {
      t2 = (evento, index) => <EventoLinhaTempo evento={evento} key={evento.id} primeiro={index === 0} ultimo={index === eventos.length - 1} />;
      $[2] = eventos.length;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = eventos.map(t2);
    $[0] = eventos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="px-[37px] pb-[18px]"><div className="rounded-[8px] border border-solid border-neutral-200 px-5 py-[18px]"><div className="flex flex-col">{t1}</div></div></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
interface EventoLinhaTempoProps {
  evento: EventoLinhaTempoSentenca;
  primeiro: boolean;
  ultimo: boolean;
}
function EventoLinhaTempo(t0) {
  const $ = _c(28);
  const {
    evento,
    primeiro,
    ultimo
  } = t0;
  const conclusao = evento.marco === "conclusao";
  const t1 = `h-1 w-0.5 ${primeiro ? "bg-transparent" : "bg-neutral-200"}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `h-3.5 w-3.5 flex-none rounded-full border-2 border-solid ${conclusao ? "border-success-500 bg-success-100" : "border-brand-600"}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `w-0.5 flex-1 ${ultimo ? "bg-transparent" : "bg-neutral-200"}`;
  let t6;
  if ($[4] !== t5) {
    t6 = <div className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t6) {
    t7 = <div className="flex w-4 flex-none flex-col items-center self-stretch">{t2}{t4}{t6}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `flex flex-1 items-baseline gap-3 ${ultimo ? "" : "pb-[14px]"}`;
  let t9;
  if ($[10] !== evento.ocorridoEm) {
    t9 = formatDate(evento.ocorridoEm);
    $[10] = evento.ocorridoEm;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <span className="w-[76px] flex-none text-[11.5px] leading-[18px] font-semibold text-neutral-500">{t9}</span>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== evento.titulo) {
    t11 = <div className="text-[13.5px] leading-[18px] font-semibold text-neutral-800">{evento.titulo}</div>;
    $[14] = evento.titulo;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== evento.descricao) {
    t12 = <div className="text-[12px] leading-[17px] text-neutral-500">{evento.descricao}</div>;
    $[16] = evento.descricao;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t13 || $[23] !== t8) {
    t14 = <div className={t8}>{t10}{t13}</div>;
    $[21] = t10;
    $[22] = t13;
    $[23] = t8;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14 || $[26] !== t7) {
    t15 = <div className="flex gap-4">{t7}{t14}</div>;
    $[25] = t14;
    $[26] = t7;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
}